import React from 'react';
import { connect } from 'react-redux';
import { getPanels } from '_helpers';
import { PatientCareCenterNoteSpecTestSection } from './Section';
import { renderRLHeader } from './Helpers';
import { PatientCareCenterNoteObjectiveSpecTestsPanel } from './SpecTestsPanel';

class SpecTestsImpingementClusterTest extends React.Component {

    render() {
        if (this.props.panels.length > 0) {
            return (
                <PatientCareCenterNoteSpecTestSection id='obj_spec_tests_ImpingementClusterTest' name='Impingement Cluster Test' visible={false} flagged={this.props.flagged}>
                    {renderRLHeader()}
                    {
                        Object.keys(this.props.panels)
                            .map(key => {
                                return (<PatientCareCenterNoteObjectiveSpecTestsPanel key={this.props.panels[key].MOPNO} panelId={this.props.panels[key].MOPNO} includeFlags={false} header='Impingement Cluster Test'/>);
                            })
                    }
                </PatientCareCenterNoteSpecTestSection>
            );
        } else {
            return (
                <span />
            )
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    let flagCount = 0;
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSIMPHAWKINSR === 'positive' ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSIMPHAWKINSL === 'positive') {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSIMPPAINFULARCR === 'positive' ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSIMPPAINFULARCL === 'positive') {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSIMPINFRASPINATUSR === 'positive' ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSIMPINFRASPINATUSL === 'positive') {
        flagCount++;
    }

    return {
        noteId: noteId,
        tsno: tsno,
        panels: getPanels(noteId, 'SpecialTest', 'ImpingementClusterTest'),
        flagged: flagCount === 3 ? true : false
    };
}

const connectedSpecTestsImpingementClusterTest = connect(mapStateToProps)(SpecTestsImpingementClusterTest);
export { connectedSpecTestsImpingementClusterTest as SpecTestsImpingementClusterTest };



